import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag";
import { windowUpdate } from './shared/common'
// controllers
import Controller from './controllers/Controller'
import NewsdirController from './controllers/NewsdirController'
import VenuesController from './controllers/VenuesController'
import VenueModalMapController from './controllers/VenueModalMapController'
import ArchiveController from './controllers/ArchiveController'
import HomePlayController from './controllers/HomePlayController'
// views
import WebflowView from './views/WebflowView'
import ListView from './views/ListView'
import ProgramMainView from './views/ProgramMainView'
import NewsView from './views/NewsView'
import IndexView from './views/IndexView'
import AccordionView from './views/AccordionView'
import VenuesView from './views/VenuesView'
import EditionTmpHomeView from './views/EditionTmpHomeView'
import HomePlayView from './views/HomePlayView'

const routes = {
  'item-webflow': { // common webflow view / controller (note diff ID!)
    controller: Controller,
    view: WebflowView
  },
  'home-playground': {
    controller: HomePlayController,
    view: HomePlayView
  },
  'list-view': {
    controller: Controller,
    view: ListView
  },
  'newsdir': {
    controller: NewsdirController,
    view: NewsView
  },
  'program-main': {
    controller: Controller,
    view: ProgramMainView
  },
  'program-filters': {
    controller: Controller,
    view: WebflowView
  },
  'index-main': {
    controller: Controller,
    view: IndexView
  },
  'accordion': {
    controller: Controller,
    view: AccordionView
  },
  'venues': {
    controller: VenuesController,
    view: VenuesView
  },
  'venue-modal-map': {
    controller: VenueModalMapController,
    view: null
  },
  'archive': {
    controller: ArchiveController,
    view: ListView
  },
  'edition_tmp_home': {
    controller: Controller,
    view: EditionTmpHomeView
  },
}

const aswapProps = {
  animationTimeHide: 800,
  animationTimeShow: 800,
  preloadOnHover: true,
  cacheOn: true,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    windowUpdate()
    WCAG.onViewChanged()
  },
  onViewHide: () => {
    // eg. close menu...
    document.documentElement.classList.remove('main-menu-open')
    document.documentElement.classList.remove('venue-map-open')
  }
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
}